/*
  only template
  prepare the ground for future development
*/

import usePRsCols from './usePRsCols';
import usePRsRows from './usePRsRows';

const usePRsLayout = ({ data } = {}) => {
  const cols = usePRsCols({ data });
  const rows = usePRsRows({ data });
  return {
    cols,
    rows
  };
};

export default usePRsLayout;
